// extracted by mini-css-extract-plugin
export default {"referralComponent":"NU","greyBack":"OU","greenBack":"PU","greenText":"QU","explainText":"RU","spinner":"SU","storedText":"TU"};
    if(module.hot) {
      // 1714654897162
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  